
import PerformanceReportSeriesResponse = App.Http.Responses.Report.PerformanceReportSeriesResponse;

type KeysUnion = keyof PerformanceReportSeriesResponse;

// TODO: could be more restrictive type-wise
export const USER_ALLOWED_KEYS: KeysUnion[] = ["click", "lead", "count", "revenue"];

export const ADMIN_ALLOWED_KEYS: KeysUnion[] = ["click", "lead", "count", "cost", "revenue", "profit", "roi"];

export const DEFAULT_USER_VISIBLE_KEYS: KeysUnion[] = [...USER_ALLOWED_KEYS];
export const DEFAULT_ADMIN_VISIBLE_KEYS: KeysUnion[] = ["click", "lead", "count", "cost", "revenue", "profit"];

export const DEFAULT_VISIBLE_KEYS = (isAdmin: boolean) => {
    return isAdmin ? DEFAULT_ADMIN_VISIBLE_KEYS : DEFAULT_USER_VISIBLE_KEYS;
};

export const ALLOWED_KEYS = (isAdmin: boolean) => {
    return isAdmin ? ADMIN_ALLOWED_KEYS : USER_ALLOWED_KEYS;
};
